import z from "zod";

export const getProtocolParamSchema = z.object({
	protocolId: z.uuid(),
});

export type GetProtocolParamSchema = z.infer<typeof getProtocolParamSchema>;
